<script setup>
import { inject, onBeforeMount, computed } from 'vue';
import FaqAccordion from '@/app/components/faq/faq-accordion.vue';
import { useFaqStore } from '@/app/stores/faqStore.js';

const config = inject('config');
const faqStore = useFaqStore();

onBeforeMount(() => {
  faqStore.checkParamsOnPageLoad();
});

onBeforeMount(() => {});
</script>

<template>
  <FaqAccordion />
</template>